import AdobeNumberField from "../../../../AdobeAriaLib/AdobeNumberField";
import AdobeYearField from "../../../../AdobeAriaLib/AdobeYearField";

interface IFormYearInputWrapper{
    value: string
    label: string
    required: boolean
    onChange: Function
    autocomplete?: string
    name?: string
    inputType?: string
}

export default function FormYearInputWrapper({value, label, required, onChange, autocomplete, name, inputType}: IFormYearInputWrapper) {
    
    function handleChange(val : string){
        onChange(val)
    }

    function isDisabled(){
        return false
    }

    return (
        <div>
            <AdobeYearField
                value={value ?? ''}
                onChangeText={handleChange}
                label={label}
                visibleLable={true}
                required={required}
                className=""
                disabled={isDisabled()}
                max={9999}
                min={1800}
                autocomplete={autocomplete}
                name={name}
                inputType={inputType} />
        </div>
    )
}